import { useMemo, useState } from "react";
import FilesView from "../../../common/filesView/FilesView";
import { formatMoney } from "../../../utils";
import RequestImageGallery from "../../ftmRequest/components/RequestImageGallery";
import Circle from "./Circle";

const AdditionalCostEstimate = ({ request_materials = [] }) => {
    const [fileViewState, setFileViewState] = useState({
        open: false,
        index: 0,
        files: []
    });

    const handleFileViewOpen = (index, files) => {
        setFileViewState({
            open: true,
            index,
            files
        });
    };

    const handleFileViewClose = () => {
        setFileViewState(prev => ({ ...prev, open: false }));
    };

    // ✅ Preprocess materials (memoized)
    const materials = useMemo(() => {
        return request_materials.map(material => {
            const files = (material?.request_material_images || []).map(item => {
                const fileName = item.request_material_image_path.split("/").pop();
                return {
                    preview: item.request_material_image_path,
                    fileName
                };
            });

            const galleryImages = files.map(file => ({
                ftm_request_image_path: file.preview
            }));

            return {
                ...material,
                files,
                galleryImages
            };
        });
    }, [request_materials]);

    // ✅ Calculate total
    const total = useMemo(() => {
        return materials.reduce(
            (sum, item) => sum + (item.request_material_net_price || 0),
            0
        );
    }, [materials]);

    return (
        <div className="card mb-3">
            <div className="card-body pb-2">
                <p className={`mt-1 mb-2 text-sm`}>
                    <b>Additional cost estimate</b>
                </p>

                <ul className="list-group">
                    {materials.map((material, index) => (
                        <li
                            key={index}
                            className="list-group-item border-0 px-0 py-2"
                        >
                            {/* Row 1 */}
                            <div className="d-flex align-items-start">
                                <Circle/>

                                <p className="mb-0 text-dark text-sm flex-grow-1 me-5 lh-sm">
                                    {material.request_material_description}
                                </p>

                                <span className="text-dark text-sm  text-nowrap">
                                    {formatMoney(material.request_material_net_price)}
                                </span>
                            </div>

                            {/* Row 2 */}
                            {material.galleryImages.length > 0 && (
                                <div className="mt-2">
                                    <RequestImageGallery
                                        images={material.galleryImages}
                                        handleFileViewOpen={(i) =>
                                            handleFileViewOpen(i, material.files)
                                        }
                                    />
                                </div>
                            )}
                        </li>
                    ))}

                    {/* ✅ Total */}
                    <li className="list-group-item border-0 px-0 pt-3">
                        <div className="d-flex align-items-start">
                            <h6 className="mb-0 text-dark text-lg flex-grow-1 me-5 lh-sm">
                                Total
                            </h6>

                            <span className="text-dark text-lg font-weight-bold text-nowrap">
                                {formatMoney(total)}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            {/* ✅ Modal */}
            <FilesView
                show={fileViewState.open}
                handleClose={handleFileViewClose}
                title="Extra materials images"
                files={fileViewState.files}
                selectedId={fileViewState.index}
            />
        </div>
    );
};

export default AdditionalCostEstimate;